/**
 * @packageDocumentation
 * @module      PropertyBindingHandler.ts
 * @description Handles binding specific properties of the given class with the event's value.
 * @copyright   Copyright (c) 2021 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
export default class PropertyBindingHandler {
    static bindPropertyWithEventTargetValue(element, targetProperty, eventTarget) {
        // @ts-ignore implicit type of any
        element[targetProperty] = eventTarget.value || '';
    }
}
//# sourceMappingURL=PropertyBindingHandler.js.map